var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:[
    'gt-capsult-button',
    _vm.round ? 'gt-capsult-button--round' : '',
    ("gt-capsult-button--" + _vm.type)
  ]},[_vm._t("default"),_vm._v("\n  "+_vm._s(_vm.text)+"\n")],2)}
var staticRenderFns = []

export { render, staticRenderFns }